// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDaySliceResponse } from './UserDaySliceResponse';
import {
    UserDaySliceResponseFromJSON,
    UserDaySliceResponseFromJSONTyped,
    UserDaySliceResponseToJSON,
    UserDaySliceResponseToJSONTyped,
} from './UserDaySliceResponse';

/**
 * 
 * @export
 * @interface DailyUsageBucketResponse
 */
export interface DailyUsageBucketResponse {
    /**
     * 
     * @type {string}
     * @memberof DailyUsageBucketResponse
     */
    day: string;
    /**
     * 
     * @type {number}
     * @memberof DailyUsageBucketResponse
     */
    conversations: number;
    /**
     * 
     * @type {number}
     * @memberof DailyUsageBucketResponse
     */
    turns: number;
    /**
     * 
     * @type {number}
     * @memberof DailyUsageBucketResponse
     */
    uniqueUsers: number;
    /**
     * 
     * @type {number}
     * @memberof DailyUsageBucketResponse
     */
    medianTurnsPerUser: number;
    /**
     * 
     * @type {Array<UserDaySliceResponse>}
     * @memberof DailyUsageBucketResponse
     */
    users: Array<UserDaySliceResponse>;
}

/**
 * Check if a given object implements the DailyUsageBucketResponse interface.
 */
export function instanceOfDailyUsageBucketResponse(value: object): value is DailyUsageBucketResponse {
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    if (!('turns' in value) || value['turns'] === undefined) return false;
    if (!('uniqueUsers' in value) || value['uniqueUsers'] === undefined) return false;
    if (!('medianTurnsPerUser' in value) || value['medianTurnsPerUser'] === undefined) return false;
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function DailyUsageBucketResponseFromJSON(json: any): DailyUsageBucketResponse {
    return DailyUsageBucketResponseFromJSONTyped(json, false);
}

export function DailyUsageBucketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyUsageBucketResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'day': json['day'],
        'conversations': json['conversations'],
        'turns': json['turns'],
        'uniqueUsers': json['unique_users'],
        'medianTurnsPerUser': json['median_turns_per_user'],
        'users': ((json['users'] as Array<any>).map(UserDaySliceResponseFromJSON)),
    };
}

export function DailyUsageBucketResponseToJSON(json: any): DailyUsageBucketResponse {
    return DailyUsageBucketResponseToJSONTyped(json, false);
}

export function DailyUsageBucketResponseToJSONTyped(value?: DailyUsageBucketResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': value['day'],
        'conversations': value['conversations'],
        'turns': value['turns'],
        'unique_users': value['uniqueUsers'],
        'median_turns_per_user': value['medianTurnsPerUser'],
        'users': ((value['users'] as Array<any>).map(UserDaySliceResponseToJSON)),
    };
}

